export default "__VITE_ASSET__BDtfHrdZ__"